import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let sceneTextEnterM: any = null,
    sceneTextLeaveM: any = null;
export default function M() {
    const { useLang, useRouter, useEffect, useState, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('smart_home_panel_2.launch.detail');
    const [textEnter, setTextEnter] = useState(false);
    const [isSafari, setIsSafari] = useState(false);
    const tableData: any = {
        thead: [
            {
                img: '/responsive/picture/smart-home-panel-2/launch/13_1.png',
                title: t('secM_item1_title'),
            },
            {
                img: '/responsive/picture/smart-home-panel-2/launch/13_2.png',
                title: t('secM_item2_title'),
            },
        ],
        tbody: [
            [
                {
                    title: t('secM_item1_list1_title'),
                    desc: t('secM_item1_list1_desc'),
                },
                {
                    title: t('secM_item2_list1_title'),
                    desc: t('secM_item2_list1_desc'),
                },
            ],
            [
                {
                    title: t('secM_item1_list2_title'),
                    desc: t('secM_item1_list2_desc'),
                },
                {
                    title: t('secM_item2_list2_title'),
                    desc: t('secM_item2_list2_desc'),
                },
            ],
            [
                {
                    title: t('secM_item1_list3_title'),
                    desc: t('secM_item1_list3_desc'),
                },
                {
                    title: t('secM_item2_list3_title'),
                    desc: t('secM_item2_list3_desc'),
                },
            ],
            [
                {
                    title: t('secM_item1_list4_title'),
                    desc: t('secM_item1_list4_desc'),
                },
                {
                    title: t('secM_item2_list4_title'),
                    desc: t('secM_item2_list4_desc'),
                },
            ],
            [
                {
                    title: t('secM_item1_list5_title'),
                    desc: t('secM_item1_list5_desc'),
                },
                {
                    title: t('secM_item2_list5_title'),
                    desc: t('secM_item2_list5_desc'),
                },
            ],
        ],
    };

    const { thead, tbody } = tableData;

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const isSafari2 = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            setIsSafari(isSafari2);
            const resizeAni = () => {
                if (sceneTextEnterM) {
                    AniContainer.removeScene(sceneTextEnterM);
                    sceneTextEnterM = null;
                }
                if (sceneTextLeaveM) {
                    AniContainer.removeScene(sceneTextLeaveM);
                    sceneTextLeaveM = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterM = AniContainer.create({
                    triggerElement: '.shp2-detail-M .text-info',
                    triggerHook: 1,
                    offset: startH,
                    duration: 200,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
            };
            resizeAni();
            // window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneTextEnterM) {
                    AniContainer.removeScene(sceneTextEnterM);
                    sceneTextEnterM = null;
                }
                if (sceneTextLeaveM) {
                    AniContainer.removeScene(sceneTextLeaveM);
                    sceneTextLeaveM = null;
                }

                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`shp2-detail-M shp2-detail-section ${css['shp2-detail-M']}`}>
            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <p className="subtitle">{t('secM_subtitle')}</p>
                <h2 className="title">{t('secM_title')}</h2>
            </div>
            <div className={`scroll-box${isSafari ? ' isSafari' : ''}`}>
                <table className="table">
                    <thead className="thead">
                        <tr className="tr th-tr">
                            {thead?.map((head: any, k: number) => (
                                <th className="th td" key="k">
                                    <div className="thead-img">
                                        <EFPicture src={head?.img} alt={head?.title} />
                                    </div>
                                    <p className="thead-title">{head?.title}</p>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="tbody">
                        {tbody?.map((row: any, m: number) => (
                            <tr className="tr" key={`${m}tr`}>
                                {row?.map((col: any, n: number) => (
                                    <td className="td" key={`${m}_${n}td`}>
                                        {/* <div className="tbody-item"> */}
                                        <p className="tbody-title">{col?.title}</p>
                                        <p className="tbody-desc">{col?.desc}</p>
                                        {/* </div> */}
                                    </td>
                                ))}
                            </tr>
                        ))}
                        <tr className="after"></tr>
                    </tbody>
                </table>
            </div>
        </section>
    );
}
